import { useTheme } from "@mui/material";
import type { StatusStyle } from "web_myplann/Goals/Types/GoalTypes";
import { GoalCoveredStateEnum } from "web_myplann/Infrastructure/Api/Api";

export const useGoalStatusStyle = (
	status: GoalCoveredStateEnum | null | undefined,
): StatusStyle => {
	const { palette } = useTheme();

	const config: Record<GoalCoveredStateEnum, StatusStyle> = {
		[GoalCoveredStateEnum.OnTrack]: {
			color: palette.success.main,
			progressColor: palette.success.main,
		},
		[GoalCoveredStateEnum.Warning]: {
			color: palette.warning.main,
			progressColor: palette.warning.main,
		},
		[GoalCoveredStateEnum.OffTrack]: {
			color: palette.error.main,
			progressColor: palette.error.main,
		},
		[GoalCoveredStateEnum.Unplanned]: {
			color: palette.grey[400],
			progressColor: palette.grey[400],
		},
	};

	const neutral: StatusStyle = {
		color: palette.success.main,
		progressColor: palette.success.main,
	};

	return (status && config[status]) || neutral;
};
